import { Component, Inject, Input, forwardRef } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }          from '../../api/api.service';
import { ConfirmOptionsModel } from './typings/confirm.options';
import { MessagesService }     from '../messages.service';

@Component({
  selector   : 'confirmation-subscribe',
  template: require('./confirmation.subscribe.component.html')
})
export class ConfirmationSubscribeComponent {
  @Input() message: string;
  @Input() options: ConfirmOptionsModel;

  private _quote : any;
  @Input() set quote ( value : any ) {
    this._quote = value;
  }
  get quote () : any {
    return this._quote;
  }

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => ApiService)) private apiService      : ApiService,
    @Inject(forwardRef(() => MessagesService)) private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  confirm () : void {
    this.apiService.get(this.options.routes.subscribe)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SUCCESSFULLY_SUBSCRIBED'), 'success');

      this.activeModal.close();
    })
    .catch(err => this.messagesService.error(err));
  }
}
